// Mock data for Indian Energreen website

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About Us', href: '#about' },
  { label: 'Services', href: '#services', dropdown: ['CBG Plant', 'Bio-Diesel', 'Bio Ethanol', 'EcoSolar', 'EV Charging'] },
  { label: 'Projects', href: '#projects' },
  { label: 'Gallery', href: '#gallery' },
  { label: 'CSR', href: '#csr' },
  { label: 'Contact', href: '#contact' },
];

export const heroStats = [
  { value: '100%', label: 'Waste Converted' },
  { value: 'PAN', label: 'India Presence' },
  { value: '24/7', label: 'Live Support' },
];

export const partners = [
  'SATAT Initiative', 'Indian Oil Corporation', 'Bharat Petroleum',
  'Hindustan Petroleum', 'Make in India', 'ISO Certified', 'Swachh Bharat',
];

export const aboutFeatures = [
  'Environmental Benefits', 'Innovation', 'Economic Growth',
  'Energy Independence', '24x7 Call & Chat Support', 'Proven Track Record',
  'Customer-Centric Approach', 'Pan India Network',
];

export const services = [
  {
    id: 'cbg',
    title: 'CBG Plant',
    icon: 'Factory',
    desc: 'Premium Compressed Biogas plants producing clean fuel from agricultural and organic waste — fully SATAT-aligned for India\'s green future.',
  },
  {
    id: 'bio-diesel',
    title: 'Bio-Diesel',
    icon: 'Fuel',
    desc: 'High-grade bio-diesel produced from renewable feedstocks — a powerful, lower-emission alternative to fossil diesel for modern engines.',
  },
  {
    id: 'bio-ethanol',
    title: 'Bio Ethanol',
    icon: 'FlaskConical',
    desc: 'Sustainable bio-ethanol blending solutions that drive cleaner transportation and reduce carbon dependence nationwide.',
  },
  {
    id: 'ecosolar',
    title: 'EcoSolar',
    icon: 'Sun',
    desc: 'Rooftop, ground-mount and hybrid solar installations for homes, businesses, and industries — premium panels, expert installation, 25-year warranty.',
  },
  {
    id: 'ev-charging',
    title: 'EV Charging',
    icon: 'Zap',
    desc: 'AC & DC fast-charging infrastructure — a future-ready charging ecosystem for India\'s electric mobility revolution.',
  },
  {
    id: 'green-hydrogen',
    title: 'Green Hydrogen',
    icon: 'Atom',
    desc: 'Next-generation green hydrogen production powered by renewable electricity — the cleanest fuel for industry and heavy mobility.',
  },
];

export const whyBio = [
  { title: 'Reduced Emissions', icon: 'Leaf', desc: 'CBG significantly lowers greenhouse gas emissions, helping fight climate change and improving air quality across regions.' },
  { title: 'Cleaner Production', icon: 'Wind', desc: 'The production and use of CBG generate fewer pollutants than traditional fossil fuels, supporting better public health.' },
  { title: 'Resource Utilization', icon: 'Recycle', desc: 'CBG converts organic and agricultural waste into valuable renewable fuel, supporting long-term energy security.' },
];

export const projects = [
  { title: 'CBG Production Facility', tag: 'Compressed Biogas', img: 'https://images.pexels.com/photos/9799743/pexels-photo-9799743.jpeg' },
  { title: 'Waste-to-Energy Plant', tag: 'Renewable Process', img: 'https://images.pexels.com/photos/32543708/pexels-photo-32543708.jpeg' },
  { title: 'Biogas Generation Unit', tag: 'Clean Methane', img: 'https://images.pexels.com/photos/414905/pexels-photo-414905.jpeg' },
  { title: 'Plant Commissioning', tag: 'PAN India', img: 'https://images.pexels.com/photos/32408717/pexels-photo-32408717.jpeg' },
  { title: 'Solar Energy Farm', tag: 'Solar Power', img: 'https://images.pexels.com/photos/37061433/pexels-photo-37061433.jpeg' },
  { title: 'EV Charging Network', tag: 'E-Mobility', img: 'https://images.pexels.com/photos/27637329/pexels-photo-27637329.jpeg' },
];

export const whyChooseUs = [
  { title: 'Advanced Technology', desc: 'State-of-the-art CBG plants with maximum methane extraction efficiency and minimal waste.' },
  { title: 'End-to-End Support', desc: 'From site survey to commissioning to daily operations — our team stays with you at every stage.' },
  { title: 'Government Backed', desc: 'SATAT scheme aligned — secured offtake agreements with IOC, BPCL, HPCL and other OMCs.' },
  { title: 'Economic Growth', desc: 'Creates local employment, supports agriculture, reduces import dependency — real community impact.' },
];

export const stats = [
  { value: '98%', label: 'Waste Converted' },
  { value: 'ISO', label: 'Certified Quality' },
  { value: 'PAN', label: 'India Network' },
  { value: '24/7', label: 'Live Support' },
];

export const presence = [
  { state: 'Uttar Pradesh', plants: 12 },
  { state: 'Maharashtra', plants: 9 },
  { state: 'Gujarat', plants: 8 },
  { state: 'Punjab', plants: 7 },
  { state: 'Rajasthan', plants: 6 },
  { state: 'Karnataka', plants: 5 },
  { state: 'Tamil Nadu', plants: 5 },
  { state: 'Madhya Pradesh', plants: 4 },
];

export const testimonials = [
  { name: 'Rajesh Kumar', role: 'Plant Operator, Punjab', quote: 'Indian Energreen helped us turn farm waste into a thriving CBG operation. Their support is unmatched.' },
  { name: 'Anita Sharma', role: 'CSR Head, FMCG Co.', quote: 'A truly end-to-end clean energy partner. Our carbon footprint dropped 40% in year one.' },
  { name: 'Vikram Patel', role: 'Farmer Cooperative, Gujarat', quote: 'They turned our agricultural residue into income while keeping our village pollution-free.' },
];

export const contact = {
  email: 'contact@indianenergreen.com',
  phone1: '+91 8930225999',
  phone2: '',
  address: 'SCO 15, HSVP Complex, Sector 4-5, Karnal 132001',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=SCO+15+HSVP+Complex+Sector+4-5+Karnal+132001',
  whatsapp: '918930225999',
};

export const googleSheetsFormEndpoint = 'https://script.google.com/macros/s/AKfycbyAwB60z8oZEnZ7JLLo4Lv3Vzo1IbzFTxWE2vW8wekKaCSl-Sm8OJhIIu9ap3tAv0GG/exec';

export const marquee = [
  'Powering a Sustainable Future', 'Fueling Tomorrow, Today',
  'Energizing a Greener World', 'Sustainable Energy for a Sustainable Future', '24x7 Support',
];
